export class AuthCredential {
  constructor(
    public readonly accessToken: string,
    public readonly refreshToken: string,
    public readonly idToken: string
  ) {}
}
